// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__FZY3J","buttonText":"style_buttonText__tggHI","buttonArrow":"style_buttonArrow__1t7k6","title":"style_title__1PBBA"};